import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../utils/firebase/firebase';
import { BASE_URL } from '../constants/AppUrl';

export const getPatientVideos = async (uid, category) => {
  try {
    const getMyVideos = httpsCallable(CloudFunctions, 'getMyVideos');

    const response = await getMyVideos({
      uid,
      category,
    });
    if (response.data.status) {
      return response.data.videos;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getAllPatientVideos = async (uid) => {
  try {
    const getAllPatientVideos = httpsCallable(
      CloudFunctions,
      'getAllPatientVideos'
    );

    const response = await getAllPatientVideos({
      uid,
    });
    if (response.data.status) {
      return response.data.videos;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchVideoDetails = async (uid, videoId) => {
  try {
    const getVideoDetailsForPatient = httpsCallable(
      CloudFunctions,
      'getVideoDetailsForPatient'
    );

    const response = await getVideoDetailsForPatient({
      uid,
      videoId,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchProcessedVideoDetails = async (uid, videoId) => {
  try {
    const getProcessedVideoInfo = httpsCallable(
      CloudFunctions,
      'getProcessedVideoInfo'
    );

    const response = await getProcessedVideoInfo({
      uid,
      videoId,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchUserVideoActivityLogs = async (uid, videoId) => {
  try {
    const getUserVideoActivityLogs = httpsCallable(
      CloudFunctions,
      'getUserVideoActivityLogs'
    );

    const response = await getUserVideoActivityLogs({
      uid,
      videoId,
    });
    // console.log("Fetching video activity logs", response);
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateVideoLogInfo = async ({
  uid,
  typeOfUser,
  patientID,
  videoId,
  info,
}) => {
  try {
    const response = await fetch(
      `${BASE_URL}/updateVideoLogInfo`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          uid,
          typeOfUser,
          patientID,
          videoId,
          info,
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error updating video log info');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling updateVideoLogInfo:', error);
    throw error;
  }
};